import React from 'react'

const SvgIcon = ({
  children,
  size = 16,
  color = 'currentColor',
  viewBox = '0 0 16 16',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={viewBox}
    fill={color}
    {...props}
  >
    {children}
  </svg>
)

export default SvgIcon
